import React from "react";
import {Link, useLocation} from "react-router-dom";


export default function WebLink(props){

	const {to, children, className = "", activeClassName = "", ...rest} = props;
	const location = useLocation();
	
	// Check if current path matches the link
	const isActive = location.pathname === to || 
		(to !== '/' && location.pathname.startsWith(to));
	
	// Combine classes with active state
	const combinedClassName = isActive 
		? `${className} ${activeClassName}`.trim()
		: className;

	return <Link to={to} className={combinedClassName} {...rest} >{children}</Link>

}

